
export enum LanguageEnum {
	en = 'en',
	cz = 'cz',
	sk = 'sk',
}


export enum AppModeEnum {
	authStart = 'authStart',
	authSuccess = 'authSuccess',
	authFailed = 'authFailed',

	initDataStart = 'initDataStart',
	initDataSuccess = 'initDataSuccess',
	initDataFailed = 'initDataFailed',

	appSuccess = 'appSuccess',
	appFailed = 'appFailed',
}